import axios from 'axios'
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import AccomplishmentsConference from './AccomplishmentsConference'
import DialogBox from './DialogBox'
import EducationalBackground from './EducationalBackground'
import MembershipsAndPublications from './MembershipsAndPublications'
import MultistepProgressbar from './MultistepProgressbar'
import OtherInfoContributions from './OtherInfoContributions'
import PersonalData from './PersonalData'
import PersonalDataContd from './PersonalDataContd'
import WorkExperience from './WorkExperience'
import Loader from './Loader'
import { Slide, Snackbar } from '@mui/material'
const UserDataUrl = "https://oaucvbuilder.onrender.com/cv/personalData"
const ExtraInfoUrl = "https://oaucvbuilder.onrender.com/cv/extraInfo"
const EducationalBackgroundUrl = "https://oaucvbuilder.onrender.com/cv/eduBackground"
const WorkExperienceUrl = "https://oaucvbuilder.onrender.com/cv/workExperience"
const MembershipPublicationUrl = "https://oaucvbuilder.onrender.com/cv/membershipAndPublications"
const ProfessionalAccomplishmentUrl = "https://oaucvbuilder.onrender.com/cv/professionalAccomplishments"
const ContributionsToKnowledgeUrl = "https://oaucvbuilder.onrender.com/cv/contributionsToKnowledge"

function CvDetails() {
  const navigate = useNavigate();
  const [currentStepIndex, setCurrentStepIndex] = useState(1);
  const [openDialogBox, setOpenDialogBox] = React.useState(false);
  const upload_preset = "tlmzrjik";
  const [loading, setloading] = useState(true);
  const signatureElement = useRef();
  

  // Fetching authentication information from local storage
  // const { auth } = useAuth();
  const auth = JSON.parse(localStorage.getItem("auth"));

  // Function to show Dialog box
  const handleClickOpenDialogBox = () => {
    setOpenDialogBox(true);
  };


  // STAGE 1: Personal Information ***/}
  const [personalDataInfo, setPersonalDataInfo] = useState({});
  // Counters
  const [childrenCount, setChildrenCount]= useState(0);


  // STAGE 2: Extra Personal Information ***/}
  const [extraPersonalDataInfo, setExtraPersonalDataInfo] = useState({});
  const [sameAddress, setSameAddress] = useState(false);

  
  // STAGE 3: Educational Background
  const [educationalBgInfo, setEducationalBgInfo] = useState({})
  // Counters
  const [schoolCount, setSchoolCount] = useState(1);
  const [scholarshipCount, setScholarshipCount] = useState(1);
  const [fellowshipCount, setFellowshipCount] = useState(1);
  const [researchGrantCount, setResearchGrantCount] = useState(1);
  const [nationalAwardCount, setNationalAwardCount] = useState(1);
  const [internationalAwardCount, setInternationalAwardCount] = useState(1);


  // STAGE 4: Work Experience
  const [workExperienceInfo, setWorkExperienceInfo] = useState({});
  // Counters
  const [nonEducationalWorkExperienceCount, SetNonEducationalWorkExperienceCount] = useState(1);
  const [otherUniWorkExperienceCount, setOtherUniWorkExperienceCount] = useState(1);;
  const [prevOauWorkExperienceCount, setPrevOauWorkExperienceCount] = useState(1);
  const [researchStudentSupervisionCount, setResearchStudentSupervisionCount] = useState(1);
  const [essayStudentSupervisionCount, setEssayStudentSupervisionCount] = useState(1);
  const [currentCoursesTaughtCount, setCurrentCoursesTaughtCount] = useState(1);


  // STAGE 5: Memberships and Publication
  const [membershipsPublicationInfo, setMembershipsPublicationInfo] = useState({});
  const [booksContributionFile, setBooksContributionFile] = useState("");
  const [uploadedBooksContributionFile, setUploadedBooksContributionFile] = useState("");
  const [academicJournalFile, setAcademicJournalFile] = useState("");
  const [uploadedAcademicJournalFile, setUploadedAcademicJournalFile] = useState("");
  const [refereedConferenceProceedingsFile, setRefereedConferenceProceedingsFile] = useState("");
  const [uploadedRefereedConferenceProceedingsFile, setUploadedRefereedConferenceProceedingsFile] = useState("");
  const [nonrefereedConferenceProceedingsFile, setNonrefereedConferenceProceedingsFile] = useState("");
  const [uploadedNonrefereedConferenceProceedingsFile, setUploadedNonrefereedConferenceProceedingsFile] = useState("");
  const [acceptedArticlesFile, setAcceptedArticlesFile] = useState("");
  const [uploadedAcceptedArticlesFile, setUploadedAcceptedArticlesFile] = useState("");
  const [submittedManuscriptFile, setSubmittedManuscriptFile] = useState("");
  const [uploadedSubmittedManuscriptFile, setUploadedSubmittedManuscriptFile] = useState("");
  const [creativeWorksFile, setCreativeWorksFile] = useState("");
  const [uploadedCreativeWorksFile, setUploadedCreativeWorksFile] = useState("");
  const [uploadedTechnicalReportFile, setUploadedTechnicalReportFile] = useState("");
  const [technicalReportFile, setTechnicalReportFile] = useState("");
  // Counters
  const [membershipCount, setMembershipCount] = useState(1);
  const [thesisDissertationsCount, setThesisDissertationsCount] = useState(1);
  const [authoredBooksMonographyCount, setAuthoredBooksMonographyCount] = useState(1);
  const [editedBooksMonographyCount, setEditedBooksMonographyCount] = useState(1);
  const [worksInProgressCount, setWorksInProgressCount] = useState(1);

  
  // STAGE 6: Accomplishment and Functions Attended
  const [accomplishmentsConferenceInfo, setAccomplishmentsConferenceInfo] = useState({});
  // Counters
  const [funtionsAttendedCount, setFuntionsAttendedCount] = useState(1);
  const [currentResearchActivityCount, setCurrentResearchActivityCount] = useState(1);

  
  // STAGE 7: Other Info and Contributions to Knowledge
  const [departmentalServiceCount, setDepartmentalServiceCount] = useState(1);
  const [facultyServiceCount, setFacultyServiceCount] = useState(1);
  const [universityServiceCount, setUniversityServiceCount] = useState(1);
  const [externalUniversityServiceCount, setExternalUniversityServiceCount] = useState(1);
  // Counters
  const [otherContributionsInfo, setOtherContributionsInfo] = useState({});
  const [userSignature, setUserSignature] = useState("");
  const [userUploadedSignature, setUserUploadedSignature] = useState("");

  

  // Function for sendng submitted information to the backend
  const sendDataInfo = async (URL, Data) =>{
    console.log("Data is :", Data);
    try {
      const response = await axios.post(URL, Data,
      {
        headers:{
          Authorization: auth.token
        }
      });
      console.log(response);
      nextButton();
    } catch (error) {
        console.log(error)
        if (error.response.status === 400){
          setShowSnackBar(true);
        }
    }
  }

  // Function handlng back button functionalities
  const prevButton = () =>{
    if (currentStepIndex>1){
      setCurrentStepIndex(currentStepIndex=>currentStepIndex-1);
    }else{
      navigate(-1)
    }
  }

  // Function handlng back button functionalities
  const nextButton = () =>{
    if (currentStepIndex<7){
      setCurrentStepIndex(currentStepIndex=>currentStepIndex+1);
    }else{
      handleClickOpenDialogBox(true)
    }
  }


  // Function for preparing entered information before sending to backend
  const submitHandler = async (e) =>{
    e.preventDefault();
    
    // Handler for Personal Information
    if (currentStepIndex === 1){
      let kidsAgeList = [];
      for (let i=0; i<childrenCount; i++){
        kidsAgeList.push(personalDataInfo[`child${i+1}`]);
      }
      sendDataInfo(UserDataUrl, {
        surname: personalDataInfo.surname, 
        otherNames: personalDataInfo.otherNames, 
        dob: personalDataInfo.dob, 
        pob:personalDataInfo.pob, 
        resAddress: personalDataInfo.resAddress, 
        gender: personalDataInfo.gender, 
        email: auth.email, 
        telNumber: personalDataInfo.telNumber, 
        nationality: personalDataInfo.nationality, 
        stateOfOrigin: personalDataInfo.stateOfOrigin, 
        sen_district: personalDataInfo.senitorial_district, 
        lga: personalDataInfo.lga, 
        permHomeAdd: personalDataInfo.permHomeAdd, 
        maritalStatus:personalDataInfo.maritalStatus, 
        kids: kidsAgeList
      });
    }


    // Handler for Extra Personal Information 
    if (currentStepIndex === 2){
      sendDataInfo(ExtraInfoUrl, {
        nextOfKinName: extraPersonalDataInfo.nextOfKinName, 
        nextOfKinResAddress: extraPersonalDataInfo.nextOfKinResAddress, 
        nextOfKinEmail: extraPersonalDataInfo.nextOfKinEmail, 
        telNoNextOfKin: extraPersonalDataInfo.telNoNextOfKin, 
        dOfConfirmAppointment: extraPersonalDataInfo.dOfConfirmAppointment, 
        firstRank: extraPersonalDataInfo.firstRank, 
        dOfLastPromotion: extraPersonalDataInfo.dOfLastPromotion, 
        dOfAssumptionOfDuty: extraPersonalDataInfo.dOfAssumptionOfDuty, 
        currentStatus: extraPersonalDataInfo.currentStatus, 
        salaryGrade: extraPersonalDataInfo.salaryGrade+" "+extraPersonalDataInfo.salarystep, 
        fac_direc: extraPersonalDataInfo.fac_direc, 
        dept_unit: extraPersonalDataInfo.dept_unit
      });
    }


    // Handler for Educational Background Information
    if (currentStepIndex === 3){
      let eduInstitutionsList = []
      let scholarshipsList = [];
      let resGrantsList = [];
      let natAwardsList = [];
      let intAwardsList = [];
      let fellowshipsList = [];
      for (let i=0; i<schoolCount; i++){
          eduInstitutionsList.push({school: educationalBgInfo[`school_of_study${i+1}`], city: educationalBgInfo[`school_of_study_city${i+1}`],
          country: educationalBgInfo[`school_of_study_country${i+1}`], qualification: educationalBgInfo[`school_degree${i+1}`], 
          field: educationalBgInfo[`field_of_Study${i+1}`], start: educationalBgInfo[`school_start_year${i+1}`], stop: educationalBgInfo[`school_end_year${i+1}`]
        });
      }
      
      for (let i=0; i<scholarshipCount; i++){
        scholarshipsList.push(educationalBgInfo[`scholarship${i+1}`]);
      }

      for (let i=0; i<researchGrantCount; i++){
        resGrantsList.push(educationalBgInfo[`research_grant${i+1}`]);
      }

      for (let i=0; i<nationalAwardCount; i++){
        natAwardsList.push(educationalBgInfo[`national_award${i+1}`]);
      }

      for (let i=0; i<internationalAwardCount; i++){
        intAwardsList.push(educationalBgInfo[`international_award${i+1}`]);
      }

      for (let i=0; i<fellowshipCount; i++){
        fellowshipsList.push(educationalBgInfo[`fellowship${i+1}`]);
      }

      sendDataInfo(EducationalBackgroundUrl, {
        eduInstitutions: eduInstitutionsList, 
        fellowships: fellowshipsList, 
        intAwards: intAwardsList, 
        natAwards: natAwardsList, 
        resGrants: resGrantsList, 
        scholarships: scholarshipsList
      });
    }


    // Handler for Work Experience
    if (currentStepIndex === 4){
      let nonEducationalWorkExperienceList = [];
      let otherUniWorkExperienceList = [];
      let prevOauWorkExperienceList = [];
      let researchStudentSupervisionList = [];
      let essayStudentSupervisionList = [];
      let currentCoursesTaughtList = [];
      let currentlySupervisedStudents = "";

      for (let i=0; i<nonEducationalWorkExperienceCount; i++){
        nonEducationalWorkExperienceList.push({title: workExperienceInfo[`employment_job_title${i+1}`], organization: workExperienceInfo[`employment_organization${i+1}`],
        city: workExperienceInfo[`employment_city${i+1}`], state: workExperienceInfo[`employment_state${i+1}`], start: workExperienceInfo[`employment_start_year${i+1}`],
        stop: workExperienceInfo[`employment_end_year${i+1}`]
        });
      }

      for (let i=0; i<otherUniWorkExperienceCount; i++){
        otherUniWorkExperienceList.push({title: workExperienceInfo[`other_uni_employment_job_title${i+1}`], university: workExperienceInfo[`other_uni_employment_name${i+1}`],
        city: workExperienceInfo[`other_uni_employment_city${i+1}`], state: workExperienceInfo[`other_uni_employment_state${i+1}`], start: workExperienceInfo[`other_uni_employment_start_year${i+1}`],
        stop: workExperienceInfo[`other_uni_employment_end_year${i+1}`]
        });
      }

      for (let i=0; i<prevOauWorkExperienceCount; i++){
        prevOauWorkExperienceList.push({title: workExperienceInfo[`prev_oau_employment_title${i+1}`], department: workExperienceInfo[`prev_oau_employment_department${i+1}`],
        start: workExperienceInfo[`prev_oau_employment_start_year${i+1}`], stop: workExperienceInfo[`prev_oau_employment_end_year${i+1}`]
        });
      }

      for (let i=0; i<researchStudentSupervisionCount; i++){
        researchStudentSupervisionList.push({name: workExperienceInfo[`research_student_name${i+1}`], matricNo: workExperienceInfo[`research_student_matric_number${i+1}`],
        topic: workExperienceInfo[`research_student_topic${i+1}`], status: workExperienceInfo[`research_student_work_status${i+1}`]
        }); 
      }

      for (let i=0; i<essayStudentSupervisionCount; i++){
        essayStudentSupervisionList.push({name: workExperienceInfo[`essay_student_name${i+1}`], matricNo: workExperienceInfo[`essay_student_matric_number${i+1}`],
        topic: workExperienceInfo[`essay_student_topic${i+1}`], status: workExperienceInfo[`essay_student_work_status${i+1}`]
        });
      }

      for (let i=0; i<currentCoursesTaughtCount; i++){
        currentCoursesTaughtList.push({title: workExperienceInfo[`currently_taught_course_title${i+1}`], code: workExperienceInfo[`currently_taught_course_code${i+1}`],
        mode: workExperienceInfo[`currently_taught_course_mode${i+1}`]
        }); 
      }

      if (workExperienceInfo.number_of_current_undergraduates_supervised){
        currentlySupervisedStudents = workExperienceInfo?.number_of_current_undergraduates_supervised;
      }

      sendDataInfo(WorkExperienceUrl, {
        gStudSupervision_essay: essayStudentSupervisionList,
        gStudSupervision_research: researchStudentSupervisionList,
        noCurrentStudents: currentlySupervisedStudents,
        pWOutSideUni: nonEducationalWorkExperienceList,
        pWOutsideOAU: otherUniWorkExperienceList,
        wInOAU: prevOauWorkExperienceList,
        coursesTaught: currentCoursesTaughtList
      });
    }


    // Handler for Memberships and Publication
    if (currentStepIndex === 5){
      let membershipList = [];
      let thesisDissertationsList = [];
      let bm_AuthoredList = [];
      let bm_EditedList = [];
      let booksContributionUrl = "";
      let academicJournalUrl = "";
      let refereedConferenceProceedingsUrl = "";
      let nonrefereedConferenceProceedingsUrl = "";
      let acceptedArticlesUrl = "";
      let submittedManuscriptUrl = "";
      let creativeWorksUrl = "";
      let technicalReportUrl = "";
      let worksInProgressList = [];

      for (let i=0; i<membershipCount; i++){
        membershipList.push(membershipsPublicationInfo[`professional_membership${i+1}`]);
      }

      for (let i=0; i<thesisDissertationsCount; i++){
        thesisDissertationsList.push({author: membershipsPublicationInfo[`Thesis_Dissertations_author${i+1}`], year: membershipsPublicationInfo[`Thesis_Dissertations_year${i+1}`], 
        title: membershipsPublicationInfo[`Thesis_Dissertations_title${i+1}`]
        });
      }

      for (let i=0; i<authoredBooksMonographyCount; i++){
        bm_AuthoredList.push(membershipsPublicationInfo[`bm_authored${i+1}`]);
      }

      for (let i=0; i<editedBooksMonographyCount; i++){
        bm_EditedList.push(membershipsPublicationInfo[`bm_edited${i+1}`]);
      }

      if (membershipsPublicationInfo.book_contribution){
        console.log(booksContributionFile);
        const doc = new FormData(); 
        doc.append('file', booksContributionFile);
        doc.append('cloud_name', "dbptb5zjv");
        doc.append('upload_preset', upload_preset);
        doc.append("resource_type", "auto");

        const response = await axios.post("https://api.cloudinary.com/v1_1/dbptb5zjv/raw/upload", doc);
        booksContributionUrl = await response.data.url;
        console.log(booksContributionUrl);
      }
      
      if (academicJournalFile){
        console.log(academicJournalFile);
        const doc = new FormData();
        doc.append('file', academicJournalFile);
        doc.append('cloud_name', "dbptb5zjv");
        doc.append('upload_preset', upload_preset);
        doc.append("resource_type", "auto");
        const response = await axios.post("https://api.cloudinary.com/v1_1/dbptb5zjv/raw/upload", doc);
        academicJournalUrl = await response.data.url;
        console.log(academicJournalUrl);
      }

      if (membershipsPublicationInfo.refereed_conference_proceedings){
        console.log(refereedConferenceProceedingsFile);
        const doc = new FormData();
        doc.append('file', refereedConferenceProceedingsFile);
        doc.append('cloud_name', "dbptb5zjv");
        doc.append('upload_preset', upload_preset);
        doc.append("resource_type", "auto");
        const response = await axios.post("https://api.cloudinary.com/v1_1/dbptb5zjv/raw/upload", doc);
        refereedConferenceProceedingsUrl = await response.data.url;
        console.log(refereedConferenceProceedingsUrl);
      }

      if (membershipsPublicationInfo.non_refereed_conference_proceedings){
        console.log(nonrefereedConferenceProceedingsFile);
        const doc = new FormData();
        doc.append('file', nonrefereedConferenceProceedingsFile);
        doc.append('cloud_name', "dbptb5zjv");
        doc.append('upload_preset', upload_preset);
        doc.append("resource_type", "auto");
        const response = await axios.post("https://api.cloudinary.com/v1_1/dbptb5zjv/raw/upload", doc);
        nonrefereedConferenceProceedingsUrl = await response.data.url;
        console.log(nonrefereedConferenceProceedingsUrl);
      }

      if (membershipsPublicationInfo.accepted_articles){
        console.log(acceptedArticlesFile);
        const doc = new FormData();
        doc.append('file', acceptedArticlesFile);
        doc.append('cloud_name', "dbptb5zjv");
        doc.append('upload_preset', upload_preset);
        doc.append("resource_type", "auto");
        const response = await axios.post("https://api.cloudinary.com/v1_1/dbptb5zjv/raw/upload", doc);
        acceptedArticlesUrl = await response.data.url;
        console.log(acceptedArticlesUrl);
      }

      if (membershipsPublicationInfo.submitted_manuscript){
        console.log(submittedManuscriptFile);
        const doc = new FormData();
        doc.append('file', submittedManuscriptFile);
        doc.append('cloud_name', "dbptb5zjv");
        doc.append('upload_preset', upload_preset);
        doc.append("resource_type", "auto");
        const response = await axios.post("https://api.cloudinary.com/v1_1/dbptb5zjv/raw/upload", doc);
        submittedManuscriptUrl = await response.data.url;
        console.log(submittedManuscriptUrl);
      }

      if (membershipsPublicationInfo.creative_works){
        console.log(creativeWorksFile);
        const doc = new FormData();
        doc.append('file', creativeWorksFile);
        doc.append('cloud_name', "dbptb5zjv");
        doc.append('upload_preset', upload_preset);
        doc.append("resource_type", "auto");
        const response = await axios.post("https://api.cloudinary.com/v1_1/dbptb5zjv/raw/upload", doc);
        creativeWorksUrl = await response.data.url;
        console.log(creativeWorksUrl);
      }

      if (membershipsPublicationInfo.technical_report){
        console.log(technicalReportFile);
        const doc = new FormData();
        doc.append('file', technicalReportFile);
        doc.append('cloud_name', "dbptb5zjv");
        doc.append('upload_preset', upload_preset);
        doc.append("resource_type", "auto");
        const response = await axios.post("https://api.cloudinary.com/v1_1/dbptb5zjv/raw/upload", doc);
        technicalReportUrl = await response.data.url;
        console.log(technicalReportUrl);
      }

      for (let i=0; i<worksInProgressCount; i++){
        worksInProgressList.push(membershipsPublicationInfo[`works_in_progress${i+1}`]);
      }

      sendDataInfo(MembershipPublicationUrl, {
        bookContributions: booksContributionUrl,
        bm_authored: bm_AuthoredList,
        bm_edited: bm_EditedList,
        nonRefConferenceProceedings: nonrefereedConferenceProceedingsUrl,
        pWInProgress: worksInProgressList,
        patents: creativeWorksUrl,
        profMembership: membershipList,
        publicationManucript: submittedManuscriptUrl,
        publicationsArticles: acceptedArticlesUrl,
        publishedJournals: academicJournalUrl,
        refConferenceProceedings: refereedConferenceProceedingsUrl,
        technicalReports: technicalReportUrl,
        thesisDissertations: thesisDissertationsList
      });
    }


    // Handler for Accomplishment and Functions Attended
    if (currentStepIndex === 6){
      let professionalAccomplishments=""
      let functionAttendedList = [];
      let currentResearchActivityList = [];
      professionalAccomplishments = accomplishmentsConferenceInfo.professional_accomplishments;

      for (let i=0; i<funtionsAttendedCount; i++){
        functionAttendedList.push(accomplishmentsConferenceInfo[`funtions_attended${i+1}`]);
      }

      for (let i=0; i<currentResearchActivityCount; i++){
        currentResearchActivityList.push(accomplishmentsConferenceInfo[`current_research_activity${i+1}`]);
      }
      
      sendDataInfo(ProfessionalAccomplishmentUrl, {
        profAccomplishments: professionalAccomplishments,
        researchActivities: currentResearchActivityList,
        seminarsWorkshops: functionAttendedList
      });
    }


    // Handler for Other Info and Contributions to Knowledge
    if (currentStepIndex === 7){
      let departmentalServiceList = [];
      let facultyServiceList = [];
      let universityServiceList = [];
      let externalUniversityServiceList = [];
      let knowledgeContribution = "";
      let dateOfSubmission = "";

      let ImageUrl;
      const signature = new FormData();
      signature.append('file', userSignature);
      signature.append('cloud_name', "dbptb5zjv");
      signature.append('upload_preset', upload_preset);

      const response = await axios.post("https://api.cloudinary.com/v1_1/dbptb5zjv/image/upload", signature);
      ImageUrl = await response.data.url;
      console.log(ImageUrl);

      knowledgeContribution = otherContributionsInfo.knowledge_contribution;
      dateOfSubmission = otherContributionsInfo.subDate;

      for (let i=0; i<departmentalServiceCount; i++){
        departmentalServiceList.push(otherContributionsInfo[`departmentalServices${i+1}`]);
      }
      
      for (let i=0; i<facultyServiceCount; i++){
        facultyServiceList.push(otherContributionsInfo[`facultyServices${i+1}`]);
      }

      for (let i=0; i<universityServiceCount; i++){
        universityServiceList.push(otherContributionsInfo[`universityService${i+1}`]);
      }

      for (let i=0; i<externalUniversityServiceCount; i++){
        externalUniversityServiceList.push(otherContributionsInfo[`externalUniversityService${i+1}`]);
      }

      sendDataInfo(ContributionsToKnowledgeUrl, {
        contribToKnowledge: knowledgeContribution,
        deptServices: departmentalServiceList,
        facultyServices: facultyServiceList,
        servicesOutsideUni: externalUniversityServiceList,
        uniServices: universityServiceList,
        signature: ImageUrl,
        dateOfSubmission: dateOfSubmission
      });
    }
  }

  // Section selector
  const currentFormComponent = () => {
    switch (currentStepIndex) {
      case 1:
        return <PersonalData personalDataInfo = {personalDataInfo} setPersonalDataInfo = {setPersonalDataInfo} childrenCount={childrenCount} setChildrenCount={setChildrenCount} />;
      case 2:
        return <PersonalDataContd personalDataInfo={personalDataInfo} extraPersonalDataInfo = {extraPersonalDataInfo} setExtraPersonalDataInfo = {setExtraPersonalDataInfo} 
          sameAddress={sameAddress} setSameAddress={setSameAddress} />;
      case 3:
        return <EducationalBackground educationalBgInfo={educationalBgInfo} setEducationalBgInfo={setEducationalBgInfo} schoolCount={schoolCount} setSchoolCount={setSchoolCount} 
          scholarshipCount ={scholarshipCount} setScholarshipCount={setScholarshipCount} fellowshipCount={fellowshipCount} setFellowshipCount={setFellowshipCount} 
          researchGrantCount={researchGrantCount} setResearchGrantCount={setResearchGrantCount} nationalAwardCount={nationalAwardCount} setNationalAwardCount={setNationalAwardCount}
          internationalAwardCount={internationalAwardCount} setInternationalAwardCount={setInternationalAwardCount} />;
      case 4:
        return <WorkExperience workExperienceInfo = {workExperienceInfo} setWorkExperienceInfo = {setWorkExperienceInfo} nonEducationalWorkExperienceCount={nonEducationalWorkExperienceCount} 
          SetNonEducationalWorkExperienceCount={SetNonEducationalWorkExperienceCount} otherUniWorkExperienceCount={otherUniWorkExperienceCount} setOtherUniWorkExperienceCount={setOtherUniWorkExperienceCount} 
          prevOauWorkExperienceCount={prevOauWorkExperienceCount} setPrevOauWorkExperienceCount={setPrevOauWorkExperienceCount} researchStudentSupervisionCount={researchStudentSupervisionCount} 
          setResearchStudentSupervisionCount={setResearchStudentSupervisionCount} currentCoursesTaughtCount = {currentCoursesTaughtCount} setCurrentCoursesTaughtCount={setCurrentCoursesTaughtCount}
          essayStudentSupervisionCount={essayStudentSupervisionCount} setEssayStudentSupervisionCount={setEssayStudentSupervisionCount} />;
      case 5:
        return <MembershipsAndPublications membershipsPublicationInfo = {membershipsPublicationInfo} setMembershipsPublicationInfo = {setMembershipsPublicationInfo} membershipCount={membershipCount} 
          setMembershipCount={setMembershipCount} thesisDissertationsCount ={thesisDissertationsCount} setThesisDissertationsCount={setThesisDissertationsCount} authoredBooksMonographyCount={authoredBooksMonographyCount} 
          setAuthoredBooksMonographyCount={setAuthoredBooksMonographyCount} editedBooksMonographyCount={editedBooksMonographyCount} setEditedBooksMonographyCount={setEditedBooksMonographyCount} 
          setWorksInProgressCount={setWorksInProgressCount} worksInProgressCount={worksInProgressCount} booksContributionFile={booksContributionFile} setBooksContributionFile={setBooksContributionFile} 
          academicJournalFile={academicJournalFile} setAcademicJournalFile = {setAcademicJournalFile} refereedConferenceProceedingsFile={refereedConferenceProceedingsFile} setRefereedConferenceProceedingsFile={setRefereedConferenceProceedingsFile}
          nonrefereedConferenceProceedingsFile={nonrefereedConferenceProceedingsFile} setNonrefereedConferenceProceedingsFile={setNonrefereedConferenceProceedingsFile} acceptedArticlesFile={acceptedArticlesFile} 
          setAcceptedArticlesFile={setAcceptedArticlesFile} submittedManuscriptFile={submittedManuscriptFile} setSubmittedManuscriptFile={setSubmittedManuscriptFile} creativeWorksFile={creativeWorksFile} 
          setCreativeWorksFile={setCreativeWorksFile} technicalReportFile={technicalReportFile} setTechnicalReportFile={setTechnicalReportFile} uploadedBooksContributionFile={uploadedBooksContributionFile} 
          setUploadedBooksContributionFile={setUploadedBooksContributionFile} uploadedAcademicJournalFile={uploadedAcademicJournalFile} setUploadedAcademicJournalFile = {setUploadedAcademicJournalFile} 
          uploadedRefereedConferenceProceedingsFile={uploadedRefereedConferenceProceedingsFile} setUploadedRefereedConferenceProceedingsFile={setUploadedRefereedConferenceProceedingsFile}
          uploadedNonrefereedConferenceProceedingsFile={uploadedNonrefereedConferenceProceedingsFile} setUploadedNonrefereedConferenceProceedingsFile={setUploadedNonrefereedConferenceProceedingsFile} 
          uploadedAcceptedArticlesFile={uploadedAcceptedArticlesFile} setUploadedAcceptedArticlesFile={setUploadedAcceptedArticlesFile} uploadedSubmittedManuscriptFile={uploadedSubmittedManuscriptFile} 
          setUploadedSubmittedManuscriptFile={setUploadedSubmittedManuscriptFile} uploadedCreativeWorksFile={uploadedCreativeWorksFile} setUploadedCreativeWorksFile={setUploadedCreativeWorksFile} 
          uploadedTechnicalReportFile={uploadedTechnicalReportFile} setUploadedTechnicalReportFile={setUploadedTechnicalReportFile} />;
      case 6:
        return <AccomplishmentsConference accomplishmentsConferenceInfo = {accomplishmentsConferenceInfo} setAccomplishmentsConferenceInfo = {setAccomplishmentsConferenceInfo} 
          funtionsAttendedCount={funtionsAttendedCount} setFuntionsAttendedCount={setFuntionsAttendedCount} currentResearchActivityCount={currentResearchActivityCount} setCurrentResearchActivityCount={setCurrentResearchActivityCount} />
      case 7:
        return <OtherInfoContributions otherContributionsInfo = {otherContributionsInfo} setOtherContributionsInfo = {setOtherContributionsInfo} departmentalServiceCount={departmentalServiceCount} 
          setDepartmentalServiceCount={setDepartmentalServiceCount} facultyServiceCount={facultyServiceCount} setFacultyServiceCount={setFacultyServiceCount} universityServiceCount={universityServiceCount} setUniversityServiceCount={setUniversityServiceCount} 
          externalUniversityServiceCount={externalUniversityServiceCount} setExternalUniversityServiceCount={setExternalUniversityServiceCount} userSignature={userSignature} setUserSignature={setUserSignature} 
          signatureElement={signatureElement} setUserUploadedSignature={setUserUploadedSignature} userUploadedSignature = {userUploadedSignature} />
      default:
        return <PersonalData personalDataInfo = {personalDataInfo} setPersonalDataInfo = {setPersonalDataInfo} childrenCount={childrenCount} setChildrenCount={setChildrenCount} />;
    }
  }
  

  // Scroll to top on every form stage change 
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' }, 0);
    
  }, [currentStepIndex]);


  // Get already stored info from backend
  useEffect(() => {
    // Personal Data
    const getPersonalData = async () =>{
      try {
        const response = await axios.get(UserDataUrl,
        {
        headers:{
          Authorization: auth?.token
        }
        });
        // console.log(response.data.detail);
        let obtainedPersonalData = {surname: response?.data?.detail?.surname, otherNames: response?.data?.detail?.otherNames, dob: response?.data?.detail?.dob, pob: response?.data?.detail?.pob, 
          resAddress: response?.data?.detail?.resAddress, gender: response?.data?.detail?.gender, email: auth?.email, telNumber: response?.data?.detail?.telNumber, nationality: response?.data?.detail?.nationality, stateOfOrigin: response?.data?.detail?.stateOfOrigin, senitorial_district: response?.data?.detail?.sen_district, 
          lga: response?.data?.detail?.lga, permHomeAdd: response?.data?.detail?.permHomeAdd, maritalStatus:response?.data?.detail?.maritalStatus
        }

        setChildrenCount(response?.data?.detail?.kids?.length);

        for (let i=0; i<response?.data?.detail?.kids?.length; i++){
          obtainedPersonalData = {...obtainedPersonalData, [`child${i+1}`]: response?.data?.detail?.kids[i]};
        }

        setPersonalDataInfo(obtainedPersonalData);

      } catch (error) {
          console.log(error)
          if (error.response.status === 400){
            // navigate('/login');
            setShowSnackBar(true);
          }
      }
    }

    // Extra Personal Data
    const getExtraPersonalData = async () =>{
      try {
        const response = await axios.get(ExtraInfoUrl,
        {
        headers:{
          Authorization: auth?.token
        }
        });
        // console.log(response.data.detail);

        let salaryInfo = response?.data?.detail?.salaryGrade?.split(" ");

        let obtainedExtraPersonalData = {
          nextOfKinName: response?.data?.detail?.nextOfKinName, nextOfKinResAddress: response?.data?.detail?.nextOfKinResAddress, nextOfKinEmail: response?.data?.detail?.nextOfKinEmail, telNoNextOfKin: response?.data?.detail?.telNoNextOfKin, 
          dOfConfirmAppointment: response?.data?.detail?.dOfConfirmAppointment, firstRank: response?.data?.detail?.firstRank, dOfLastPromotion: response?.data?.detail?.dOfLastPromotion, 
          dOfAssumptionOfDuty: response?.data?.detail?.dOfAssumptionOfDuty, currentStatus: response?.data?.detail?.currentStatus, salaryGrade: salaryInfo[0]+" "+salaryInfo[1]+" "+salaryInfo[2], salarystep: salaryInfo[3]+" "+salaryInfo[4], 
          fac_direc: response?.data?.detail?.fac_direc, dept_unit: response?.data?.detail?.dept_unit
        };

        setExtraPersonalDataInfo(obtainedExtraPersonalData);

      } catch (error) {
          console.log(error)
          if (error.response.status === 400){
            setShowSnackBar(true);
          }
      }
    }

    const getEducationalData = async () =>{
      try {
        const response = await axios.get(EducationalBackgroundUrl,
        {
        headers:{
            Authorization: auth?.token
        }
        });

        let obtainedEduData = {};
        setSchoolCount(response?.data?.detail?.eduInstitutions?.length);
        for (let i=0; i<response?.data?.detail?.eduInstitutions?.length; i++){
            obtainedEduData = {...obtainedEduData, [`school_of_study${i+1}`]: response?.data?.detail?.eduInstitutions[i]?.school, [`school_of_study_city${i+1}`]: response?.data?.detail?.eduInstitutions[i]?.city,
            [`school_of_study_country${i+1}`]: response?.data?.detail?.eduInstitutions[i]?.country, [`school_degree${i+1}`]: response?.data?.detail?.eduInstitutions[i]?.qualification, [`field_of_Study${i+1}`]: response?.data?.detail?.eduInstitutions[i]?.field,
            [`school_start_year${i+1}`]: response?.data?.detail?.eduInstitutions[i]?.start, [`school_end_year${i+1}`]: response?.data?.detail?.eduInstitutions[i]?.stop}
        }

        setScholarshipCount(response?.data?.detail?.scholarships?.length);
        setFellowshipCount(response?.data?.detail?.fellowships?.length);
        setResearchGrantCount(response?.data?.detail?.resGrants?.length);
        setNationalAwardCount(response?.data?.detail?.natAwards?.length);
        setInternationalAwardCount(response?.data?.detail?.intAwards?.length);

        for (let i=0; i<response?.data?.detail?.scholarships?.length; i++){
          obtainedEduData = {...obtainedEduData, [`scholarship${i+1}`]: response?.data?.detail?.scholarships[i]};
        }

        for (let i=0; i<response?.data?.detail?.resGrants?.length; i++){
          obtainedEduData = {...obtainedEduData, [`research_grant${i+1}`]: response?.data?.detail?.resGrants[i]};
        }

        for (let i=0; i<response?.data?.detail?.natAwards?.length; i++){
          obtainedEduData = {...obtainedEduData, [`national_award${i+1}`]: response?.data?.detail?.natAwards[i]};
        }

        for (let i=0; i<response?.data?.detail?.intAwards?.length; i++){
          obtainedEduData = {...obtainedEduData, [`international_award${i+1}`]: response?.data?.detail?.intAwards[i]};
        }

        for (let i=0; i<response?.data?.detail?.fellowships?.length; i++){
          obtainedEduData = {...obtainedEduData, [`fellowship${i+1}`]: response?.data?.detail?.fellowships[i]};
        }

        setEducationalBgInfo(obtainedEduData);
      } catch (error) {
        console.log(error)
        if (error.response.status === 400){
          setShowSnackBar(true);
        }
      }
    }


    // Work Experience
    const getWorkExpData = async () =>{
      try {
        const response = await axios.get(WorkExperienceUrl,
        {
        headers:{
            Authorization: auth?.token
        }
        });
        console.log(response.data.detail);

        let workExpData = {};
        SetNonEducationalWorkExperienceCount(response?.data?.detail?.pWOutSideUni?.length);
        setOtherUniWorkExperienceCount(response?.data?.detail?.pWOutsideOAU?.length);
        setPrevOauWorkExperienceCount(response?.data?.detail?.wInOAU?.length);
        setResearchStudentSupervisionCount(response?.data?.detail?.gStudSupervision_research?.length);
        setEssayStudentSupervisionCount(response?.data?.detail?.gStudSupervision_essay?.length);
        setCurrentCoursesTaughtCount(response?.data?.detail?.coursesTaught?.length);

        for (let i=0; i<response?.data?.detail?.pWOutSideUni?.length; i++){
            workExpData = {...workExpData, [`employment_job_title${i+1}`]: response?.data?.detail?.pWOutSideUni[i]?.title, [`employment_organization${i+1}`]: response?.data?.detail?.pWOutSideUni[i]?.organization,
            [`employment_city${i+1}`]: response?.data?.detail?.pWOutSideUni[i]?.city, [`employment_state${i+1}`]: response?.data?.detail?.pWOutSideUni[i]?.state, 
            [`employment_start_year${i+1}`]: response?.data?.detail?.pWOutSideUni[i]?.start, [`employment_end_year${i+1}`]: response?.data?.detail?.pWOutSideUni[i]?.stop
          }
        }

        for (let i=0; i<response?.data?.detail?.pWOutsideOAU?.length; i++){
            workExpData = {...workExpData, [`other_uni_employment_job_title${i+1}`]: response?.data?.detail?.pWOutsideOAU[i]?.title, [`other_uni_employment_name${i+1}`]: response?.data?.detail?.pWOutsideOAU[i]?.university,
            [`other_uni_employment_city${i+1}`]: response?.data?.detail?.pWOutsideOAU[i]?.city, [`other_uni_employment_state${i+1}`]: response?.data?.detail?.pWOutsideOAU[i]?.state, 
            [`other_uni_employment_start_year${i+1}`]: response?.data?.detail?.pWOutsideOAU[i]?.start, [`other_uni_employment_end_year${i+1}`]: response?.data?.detail?.pWOutsideOAU[i]?.stop
          }
        }
        for (let i=0; i<response?.data?.detail?.wInOAU?.length; i++){
            workExpData = {...workExpData, [`prev_oau_employment_title${i+1}`]: response?.data?.detail?.wInOAU[i]?.title, [`prev_oau_employment_department${i+1}`]: response?.data?.detail?.wInOAU[i]?.department,
            [`prev_oau_employment_start_year${i+1}`]: response?.data?.detail?.wInOAU[i]?.start, [`prev_oau_employment_end_year${i+1}`]: response?.data?.detail?.wInOAU[i]?.stop
          }
        }
        for (let i=0; i<response?.data?.detail?.gStudSupervision_research?.length; i++){
            workExpData = {...workExpData, [`research_student_name${i+1}`]: response?.data?.detail?.gStudSupervision_research[i]?.name, [`research_student_matric_number${i+1}`]: response?.data?.detail?.gStudSupervision_research[i]?.matricNo,
            [`research_student_topic${i+1}`]: response?.data?.detail?.gStudSupervision_research[i]?.topic, [`research_student_work_status${i+1}`]: response?.data?.detail?.gStudSupervision_research[i]?.status
          }
        }
        for (let i=0; i<response?.data?.detail?.gStudSupervision_essay?.length; i++){
            workExpData = {...workExpData, [`essay_student_name${i+1}`]: response?.data?.detail?.gStudSupervision_essay[i]?.name, [`essay_student_matric_number${i+1}`]: response?.data?.detail?.gStudSupervision_essay[i]?.matricNo,
            [`essay_student_topic${i+1}`]: response?.data?.detail?.gStudSupervision_essay[i]?.topic, [`essay_student_work_status${i+1}`]: response?.data?.detail?.gStudSupervision_essay[i]?.status
          }
        }
        for (let i=0; i<response?.data?.detail?.coursesTaught?.length; i++){
            workExpData = {...workExpData, [`currently_taught_course_title${i+1}`]: response?.data?.detail?.coursesTaught[i]?.title, [`currently_taught_course_code${i+1}`]: response?.data?.detail?.coursesTaught[i]?.code,
            [`currently_taught_course_mode${i+1}`]: response?.data?.detail?.coursesTaught[i]?.mode
          }
        }

        workExpData = {...workExpData, number_of_current_undergraduates_supervised: response?.data?.detail?.noCurrentStudents}
        // console.log(workExpData);
        setWorkExperienceInfo(workExpData);
      } catch (error) {
        console.log(error)
        if (error.response.status === 400){
          setShowSnackBar(true);
        }
      }
    }

    // Memberships and Publications
    const getMembPubData = async () =>{
      try {
        const response = await axios.get(MembershipPublicationUrl,
        {
        headers:{
            Authorization: auth?.token
        }
        });

        console.log(response.data);

        let membPubData = {};
        setMembershipCount(response?.data?.detail?.profMembership?.length);
        setThesisDissertationsCount(response?.data?.detail?.thesisDissertations?.length);
        setAuthoredBooksMonographyCount(response?.data?.detail?.bm_authored?.length);
        setEditedBooksMonographyCount(response?.data?.detail?.bm_edited?.length);
        setWorksInProgressCount(response?.data?.detail?.pWInProgress?.length);

        for (let i=0; i<response?.data?.detail?.profMembership?.length; i++){
          membPubData = {...membPubData, [`professional_membership${i+1}`]: response?.data?.detail?.profMembership[i]}
        }

        for (let i=0; i<response?.data?.detail?.profMembership?.length; i++){
          membPubData = {...membPubData, [`bm_authored${i+1}`]: response?.data?.detail?.bm_authored[i]}
        }

        for (let i=0; i<response?.data?.detail?.profMembership?.length; i++){
          membPubData = {...membPubData, [`bm_edited${i+1}`]: response?.data?.detail?.bm_edited[i]}
        }

        for (let i=0; i<response?.data?.detail?.profMembership?.length; i++){
          membPubData = {...membPubData, [`works_in_progress${i+1}`]: response?.data?.detail?.pWInProgress[i]}
        }

        for (let i=0; i<response?.data?.detail?.pWOutsideOAU?.length; i++){
          membPubData = {...membPubData, [`Thesis_Dissertations_author${i+1}`]: response?.data?.detail?.thesisDissertations[i]?.title, [`Thesis_Dissertations_year${i+1}`]: response?.data?.detail?.thesisDissertations[i]?.year,
            [`Thesis_Dissertations_title${i+1}`]: response?.data?.detail?.thesisDissertations[i]?.title
          }
        }

        setBooksContributionFile(response?.data?.detail?.bookContributions);
        setAcademicJournalFile(response?.data?.detail?.publishedJournals);
        setRefereedConferenceProceedingsFile(response?.data?.detail?.refConferenceProceedings);
        setNonrefereedConferenceProceedingsFile(response?.data?.detail?.nonRefConferenceProceedings);
        setAcceptedArticlesFile(response?.data?.detail?.publicationsArticles);
        setSubmittedManuscriptFile(response?.data?.detail?.publicationManucript);
        setCreativeWorksFile(response?.data?.detail?.patents);
        setTechnicalReportFile(response?.data?.detail?.technicalReports);

        console.log(response?.data?.detail?.bookContributions);
        
        const uploadedBookContribution = new File([response?.data?.detail?.bookContributions], 'books.xlsx', {
          type: '.xlsx, .xls, .csv',
          lastModified: new Date(),
          webkitRelativePath: response?.data?.detail?.bookContributions
        });
        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(uploadedBookContribution);
        setUploadedBooksContributionFile(dataTransfer.files);

        const uploadedJournalContribution = new File([response?.data?.detail?.publishedJournals], 'journals.xlsx', {
          type: '.xlsx, .xls, .csv',
          lastModified: new Date(),
          webkitRelativePath: response?.data?.detail?.publishedJournals
        });
        const journalDataTransfer = new DataTransfer();
        journalDataTransfer.items.add(uploadedJournalContribution);
        setUploadedAcademicJournalFile(journalDataTransfer.files);

        const uploadedrefConferenceProceedings = new File([response?.data?.detail?.refConferenceProceedings], 'refConferenceProceedings.xlsx', {
          type: '.xlsx, .xls, .csv',
          lastModified: new Date(),
          webkitRelativePath: response?.data?.detail?.refConferenceProceedings
        });
        const refConferenceProceedingsDataTransfer = new DataTransfer();
        refConferenceProceedingsDataTransfer.items.add(uploadedrefConferenceProceedings);
        setUploadedRefereedConferenceProceedingsFile(refConferenceProceedingsDataTransfer.files);

        const uploadednonRefConferenceProceedings = new File([response?.data?.detail?.nonRefConferenceProceedings], 'nonrefConferenceProceedings.xlsx', {
          type: '.xlsx, .xls, .csv',
          lastModified: new Date(),
          webkitRelativePath: response?.data?.detail?.nonRefConferenceProceedings
        });
        const nonRefConferenceProceedingsDataTransfer = new DataTransfer();
        nonRefConferenceProceedingsDataTransfer.items.add(uploadednonRefConferenceProceedings);
        setUploadedNonrefereedConferenceProceedingsFile(nonRefConferenceProceedingsDataTransfer.files);

        const uploadedpublicationsArticles = new File([response?.data?.detail?.publicationsArticles], 'publicationsArticles.xlsx', {
          type: '.xlsx, .xls, .csv',
          lastModified: new Date(),
          webkitRelativePath: response?.data?.detail?.publicationsArticles
        });
        const publicationsArticlesTransfer = new DataTransfer();
        publicationsArticlesTransfer.items.add(uploadedpublicationsArticles);
        setUploadedAcceptedArticlesFile(publicationsArticlesTransfer.files);

        const uploadedpublicationManucript = new File([response?.data?.detail?.publicationManucript], 'publicationManucript.xlsx', {
          type: '.xlsx, .xls, .csv',
          lastModified: new Date(),
          webkitRelativePath: response?.data?.detail?.publicationManucript
        });
        const publicationManucriptDataTransfer = new DataTransfer();
        publicationManucriptDataTransfer.items.add(uploadedpublicationManucript);
        setUploadedSubmittedManuscriptFile(publicationManucriptDataTransfer.files);

        const uploadedPatents = new File([response?.data?.detail?.patents], 'patents.xlsx', {
          type: '.xlsx, .xls, .csv',
          lastModified: new Date(),
          webkitRelativePath: response?.data?.detail?.patents
        });
        const patentsDataTransfer = new DataTransfer();
        patentsDataTransfer.items.add(uploadedPatents);
        setUploadedCreativeWorksFile(patentsDataTransfer.files);

        const uploadedTechnicalReport = new File([response?.data?.detail?.technicalReports], 'technicalReports.xlsx', {
          type: '.xlsx, .xls, .csv',
          lastModified: new Date(),
          webkitRelativePath: response?.data?.detail?.technicalReports
        });
        const technicalReportsDataTransfer = new DataTransfer();
        technicalReportsDataTransfer.items.add(uploadedTechnicalReport);
        setUploadedTechnicalReportFile(technicalReportsDataTransfer.files);
        
        setMembershipsPublicationInfo(membPubData);
      } catch (error) {
          console.log(error)
          if (error.response.status === 400){
            setShowSnackBar(true);
          }
      }
    }

    // Professional Accomplishments 
    const getProfAccData = async () =>{
      try {
        const response = await axios.get(ProfessionalAccomplishmentUrl,
        {
        headers:{
            Authorization: auth?.token
        }
        });
        // console.log(response.data.detail);
        let profAccData = {};
        setCurrentResearchActivityCount(response?.data?.detail?.researchActivities?.length);
        setFuntionsAttendedCount(response?.data?.detail?.seminarsWorkshops?.length);
        
        profAccData = {...profAccData, professional_accomplishments: response?.data?.detail?.profAccomplishments}

        for (let i=0; i<response?.data?.detail?.researchActivities?.length; i++){
          profAccData = {...profAccData, [`funtions_attended${i+1}`]: response?.data?.detail?.researchActivities[i]}
        }

        for (let i=0; i<response?.data?.detail?.profMembership?.length; i++){
          profAccData = {...profAccData, [`current_research_activity${i+1}`]: response?.data?.detail?.seminarsWorkshops[i]}
        } 

        // console.log(profAccData);
        setAccomplishmentsConferenceInfo(profAccData);
      } catch (error) {
        console.log(error)
        if (error.response.status === 400){
          setShowSnackBar(true);
        }
      }
    }

    const getOtherInfoData = async () =>{
      try {
        const response = await axios.get(ContributionsToKnowledgeUrl,
        {
        headers:{
            Authorization: auth?.token
        }
        });
        // console.log(response.data.detail);

        let otherInfoData = {};
        setDepartmentalServiceCount(response?.data?.detail?.deptServices?.length);
        setFacultyServiceCount(response?.data?.detail?.facultyServices?.length);
        setUniversityServiceCount(response?.data?.detail?.uniServices?.length);
        setExternalUniversityServiceCount(response?.data?.detail?.servicesOutsideUni?.length);
        
        otherInfoData = {...otherInfoData, knowledge_contribution: response?.data?.detail?.contribToKnowledge}
        // otherInfoData = {...otherInfoData, subDate: response.data.detail.subDate}

        for (let i=0; i<response?.data?.detail?.deptServices?.length; i++){
          otherInfoData = {...otherInfoData, [`departmentalServices${i+1}`]: response?.data?.detail?.deptServices[i]}
        }

        for (let i=0; i<response?.data?.detail?.facultyServices?.length; i++){
          otherInfoData = {...otherInfoData, [`facultyServices${i+1}`]: response?.data?.detail?.facultyServices[i]}
        } 

        for (let i=0; i<response?.data?.detail?.uniServices?.length; i++){
          otherInfoData = {...otherInfoData, [`universityService${i+1}`]: response?.data?.detail?.uniServices[i]}
        }

        for (let i=0; i<response?.data?.detail?.deptServices?.length; i++){
          otherInfoData = {...otherInfoData, [`externalUniversityService${i+1}`]: response?.data?.detail?.servicesOutsideUni[i]}
        }

        setUserSignature(response?.data?.detail?.signature);
        
        const uploadedSignature = new File([response?.data?.detail?.signature], 'signature.png', {
          type: 'image/*',
          lastModified: new Date(),
          webkitRelativePath: response?.data?.detail?.signature
        });
        otherInfoData = {...otherInfoData, subDate: response?.data?.detail?.dateOfSubmission}

        // console.log(otherInfoData);
        setOtherContributionsInfo(otherInfoData);

        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(uploadedSignature);
        setUserUploadedSignature(dataTransfer.files);
        setloading(false);
      } catch (error) {
        console.log(error)
        if (error.response.status === 400){
          setShowSnackBar(true);
        }
      }
    }
    if (auth.firstTimer === false){
      getPersonalData();
      getExtraPersonalData();
      getEducationalData();
      getWorkExpData();
      getMembPubData();
      getProfAccData();
      getOtherInfoData();
    }else{
      setloading(false);
    }

  }, [])

  // State to show snackbar 
  const [showSnackBar, setShowSnackBar] = useState(false);

  //  Function to close snackbar 
  const closeSnackBar = (event, reason) =>{
    if (reason === 'clickaway') {
      return;
    }
    setShowSnackBar(false);
    navigate("/login");
  }

  // Snackbar animation letting it slide from the left
  function TransitionLeft(props) {
    return <Slide {...props} direction="left" />;
  }

  return (
    <div className='h-full w-full py-8'>
      { loading && <Loader /> }
      {openDialogBox && <DialogBox setOpenDialogBox={setOpenDialogBox} openDialogBox={openDialogBox} />}
      <Snackbar
        open={showSnackBar}
        autoHideDuration={4000}
        onClose={closeSnackBar}
        TransitionComponent={TransitionLeft}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        ContentProps={{
          sx: {
            background: "#3e4095"
          }
        }}
        message="Session Expired! Redirecting to Login..."
      />

      <form onSubmit={submitHandler} className='w-11/12 mx-auto flex flex-col gap-3 lg:w-8/12 pt-12 pb-10 sm:pt-14 md:px-14 md:shadow-lg'>
        <div className='flex flex-col box-border gap-2'>
          <div className='my-6 px-1 box-border'>
            <MultistepProgressbar setCurrentStepIndex={setCurrentStepIndex} step={currentStepIndex}/>
          </div>
          {currentFormComponent()}
          <div className='flex flex-row justify-between mt-4'>
            <button type='button' onClick={prevButton} className='py-4 w-[170px] text-custom-blue font-medium text-base md:text-lg rounded-md hover:bg-custom-yellow hover:text-white cursor-pointer'>
              { currentStepIndex === 1 ? "Cancel" : "Back" }
            </button>
            <button type='submit' className='py-4 w-[170px] text-white font-medium text-base md:text-lg rounded-md hover:bg-custom-blue bg-custom-dark-blue hover:text-slate-400 cursor-pointer'>
              { currentStepIndex === 7 ? "Submit" : "Save & Next" }
            </button>
          </div>
        </div>
      </form>
    </div>
  )
}

export default CvDetails